/** A structural invariant of §4.7 failed. `offset` is the SRAM file offset of the offending byte. */
export class SaveFormatError extends Error {
  readonly offset: number;
  constructor(message: string, offset: number) {
    super(`${message} (at 0x${offset.toString(16).padStart(4, "0")})`);
    this.name = "SaveFormatError";
    this.offset = offset;
  }
}

/** A non-fatal irregularity found while parsing (glitch species, mismatched species list, odd item list). */
export interface SaveIssue {
  offset: number;
  message: string;
}
